<template>
  <el-dropdown trigger="hover" class="international" @command="handleSetTenant">
    <div>
        <i class="international-icon el-icon-office-building"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in tenantList" :disabled="currentTenant==item.tenantId" :key="item.tenantId" :command="item">{{item.tenantName}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  computed: {
    tenantList() {
      return this.$store.getters.tenantList
    },
    currentTenant() {
      return this.$store.getters.currentTenant;
    },
  },
  methods: {
    handleSetTenant(tenant) {
      let prevTenantId = this.$store.getters.currentTenant
      let tenantId = tenant.tenantId
      this.$store.dispatch('SetCurrentTenant', {tenantId: tenantId, productKey: tenant.productKey, menu: true}).then(()=>{
        if(prevTenantId == "-1" || tenantId == "-1") {
          location.replace(location.href.substring(0, location.href.indexOf("#/")+1))
        }
        location.reload()
      })
    }
  }
}
</script>

<style scoped>
.international-icon {
  font-size: 26px;
  cursor: pointer;
  vertical-align: -5px!important;
}
</style>
